import HomeComponent from "./Component";
import { useHomeHook } from "./Hook";

const Home = () => {
  return <HomeComponent {...useHomeHook()} />;
};

export default Home;
